(() => {
  let cartButton = null;
  let originalOffsetTop = null;
  let isCartFixed = false;
  let originalParent, originalNextSibling, cloneThumbnails, thumbnailModalOverlay = null;
  let thumbnailModalOpen = false;
  let originalWishlistParent = null;
  let originalWishlistNextSibling = null;
  let isWishlistMoved = false;
  let hasRun = false;

  // プライバシーポリシー同意チェック
  const initPrivacyPolicyCheck = () => {
    let submitButton = null;
    let checkbox = null;
    const registerCheckbox = document.getElementById('register_optin');
    const contactCheckbox = document.getElementById('contact_optin');
    const cartCheckbox = document.getElementById('cart_optin');

    if (registerCheckbox) {
      submitButton = document.querySelector('.customer.register .submit_button');
      checkbox = registerCheckbox;
    } else if (contactCheckbox) {
      submitButton = document.querySelector('.contact .submit_button');
      checkbox = contactCheckbox;
    } else if(cartCheckbox) {
      submitButton = document.querySelector('.cart-notification .submit_button');
      checkbox = cartCheckbox;
    }

    if (!submitButton) return;
    submitButton.disabled = !checkbox.checked;

    checkbox.addEventListener('change', () => {
      submitButton.disabled = !checkbox.checked;
    });
  };

  const initProductPrivacyPolicyCheck = () => {
    const productCheckbox = document.getElementById('product_optin');
    const paymentButton = document.querySelector('.shopify-payment-button');

    if (!productCheckbox || !paymentButton) return;

    const setPointerEvents = (ok) => {
      paymentButton.style.pointerEvents = ok ? 'auto' : 'none';
      paymentButton.style.opacity = ok ? '' : '0.7';
    };

    setPointerEvents(productCheckbox.checked);

    productCheckbox.addEventListener('change', () => {
      setPointerEvents(productCheckbox.checked);
    });
  };

  // 選択中のバリエーションカラー名を取得
  const initColorTextUpdater = () => {
    const colorTxt = document.getElementById('color_txt');
    const colorInputs = document.querySelectorAll('input[name="カラー"]');

    if (colorTxt && colorInputs.length > 0) {
      colorInputs.forEach(input => {
        input.addEventListener('input', () => {
          colorTxt.textContent = input.value;
        });

        if (input.checked) {
          colorTxt.textContent = input.value;
        }
      });
    }
  };

  // カートボタン追従
  const initCartButtonTracking = () => {
    cartButton = document.querySelector('[id^="cart-fixed-button-"]');
    if (cartButton) {
      originalOffsetTop = cartButton.getBoundingClientRect().top + window.pageYOffset;
    }
  };

  // 選択中のバリエーション送料を取得
  const initShippingDisplay = () => {
    const shippingDisplay = document.getElementById('delivery-shipping');
    const shippingArea = document.getElementById('delivery-shipping-area');
    if (!shippingDisplay || !shippingArea) return;

    const radios = document.querySelectorAll('.variant-radios input[type="radio"]');
    const updateShipping = (radio) => {
      const label = radio.nextElementSibling;
      const hiddenSpan = label?.querySelector('span.hidden');
      const shippingText = hiddenSpan?.textContent.trim();

      if (shippingText) {
        shippingDisplay.textContent = shippingText;
        shippingArea.style.display = '';
      } else {
        shippingArea.style.display = 'none';
      }
    };

    radios.forEach((radio) => {
      if (radio.checked) updateShipping(radio);
      radio.addEventListener('change', () => {
        if (radio.checked) updateShipping(radio);
      });
    });
  };

  // もっと見るボタン表示
  const initReadMore = () => {
    document.querySelectorAll('.js-description').forEach((description) => {
      if (description.dataset.readMoreBound === 'true') return;

      const toggleBtn = description.querySelector('.read-more__button');
      if (!toggleBtn) return;

      const isOpen = description.classList.contains('is-expanded');
      toggleBtn.textContent = isOpen ? 'CLOSE' : 'READ MORE';
      toggleBtn.setAttribute('aria-expanded', String(isOpen));

      toggleBtn.addEventListener('click', () => {
        description.classList.toggle('is-expanded');
        const open = description.classList.contains('is-expanded');
        toggleBtn.textContent = open ? 'CLOSE' : 'READ MORE';
        toggleBtn.setAttribute('aria-expanded', String(open));
      });

      description.dataset.readMoreBound = 'true';
    });
  };

  const thumbnailOpenModal = () => {
    if (thumbnailModalOpen) return;
    thumbnailModalOverlay = document.getElementById('thumbnail-modal-overlay');
    thumbnailModalOverlay.addEventListener('click', thumbnailCloseModal);

    const sliderThumbnails = document.querySelector('[id^="Slider-Thumbnails-"]');
    (sliderThumbnails.querySelectorAll('.thumbnail-list__item')).forEach((item) => {
      item.addEventListener('click', thumbnailCloseModal);
    });

    originalParent = sliderThumbnails.parentNode;
    originalNextSibling = sliderThumbnails.nextSibling;
    cloneThumbnails = sliderThumbnails.cloneNode(true);
    originalParent.insertBefore(cloneThumbnails, originalNextSibling);

    let thumbnailModalContent = document.getElementById('thumbnail-modal-content');
    thumbnailModalContent.appendChild(sliderThumbnails);

    const thumbnailModal = document.getElementById('thumbnail-modal');
    thumbnailModal.style.display = 'block';

    document.body.classList.add('modal-open');
    thumbnailModalOpen = true;
  };

  const thumbnailCloseModal = () => {
    if (!thumbnailModalOpen) return;
    if (cloneThumbnails) originalParent.removeChild(cloneThumbnails);

    const sliderThumbnails = document.querySelector('[id^="Slider-Thumbnails-"]');
    originalParent.insertBefore(sliderThumbnails, originalNextSibling);

    document.body.classList.remove('modal-open');
    setTimeout(() => {
      const thumbnailModal = document.getElementById('thumbnail-modal');
      thumbnailModal.style.display = 'none';
    }, 0);
    thumbnailModalOpen = false;
  };

  // 商品画像一覧モーダル
  const initThumbnailModal = () => {
    const galleryThumbnails = document.querySelector('[id^="GalleryThumbnails-"]');
    if (galleryThumbnails) {
      const showModalButton = document.getElementById('show-modal-button');
      showModalButton.style.display = 'flex';
      showModalButton.addEventListener('click', thumbnailOpenModal);

      const closeModalButton = document.getElementById('close-modal-button');
      closeModalButton.addEventListener('click', thumbnailCloseModal);
    }
  };

  // 送料無料バーの高さを取得
  const initFreeShippingBarMargin = () => {
    const targetId = 'free-shipping-bar-container';
    const setMarginTop = () => {
      const bar = document.getElementById(targetId);

      if (bar) {
        const outerDiv = bar.querySelector('div');
        const innerDiv = outerDiv?.querySelector('div');

        if (outerDiv) {
          outerDiv.style.height = 'auto';
          const height = innerDiv.offsetHeight;
          document.body.style.marginTop = `${height}px`;
        }
      }
    };

    const observer = new MutationObserver(() => {
      setMarginTop();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  // カート通知モーダル調整
  const initCartNotification = () => {
    const cartNotification = document.getElementById('cart-notification');
    const body = document.body;

    if (cartNotification) {
      cartNotification.addEventListener('transitionend', function() {
        if (cartNotification.classList.contains('active')) {
          body.classList.add('is-cart-modal');
        } else {
          body.classList.remove('is-cart-modal');
        }
      });
    }
  };

  // ヤマト最短お届け日時テキスト変更
  const initReplaceCheckTimeText = () => {
    const text = document.querySelector('#check_delivery_time .check_time-description > span');
    if (text) {
      text.innerHTML = text.innerHTML.replace('届け予定日', 'お届け予定日');
      text.innerHTML = text.innerHTML.replace('ヤマト運輸での', '');
    }
  }

  // トップに戻るボタン表示
  const initBackToTopButton = () => {
    const backToTopButton = document.getElementById('back-to-top');

    window.addEventListener('scroll', () => {
      backToTopButton.classList.toggle('show', window.scrollY > 300);
    });

    backToTopButton.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  };

  // Shopify Inbox
  const initInbox = () => {
    const observer = new MutationObserver(() => {
      const inbox = document.querySelector('inbox-online-store-chat');
      if (inbox?.shadowRoot) {
        let style = inbox.shadowRoot.getElementById('inbox-btn-style');
        if (!style) {
          style = document.createElement('style');
          style.id = 'inbox-btn-style';
          inbox.shadowRoot.appendChild(style);
        }
        style.textContent = `
          button.chat-toggle--icon-button,
          button.chat-app--close-button {
            width: 50px !important;
            height: 50px !important;
          }

          button.chat-toggle--icon-button svg,
          button.chat-app--close-button svg {
            height: 48px !important;
          }
        `;
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  const initInboxOpenState = () => {
    const CLASS_NAME = 'is-inbox-open';
    const watcher = new MutationObserver(() => {
      const shopifyChat = document.getElementById('ShopifyChat');
      if (shopifyChat) {
        watcher.disconnect();

        const updateBodyClass = () => {
          const isOpen = shopifyChat.getAttribute('is-open') === 'true';
          document.body.classList.toggle(CLASS_NAME, isOpen);
        };

        updateBodyClass();
        new MutationObserver(updateBodyClass)
          .observe(shopifyChat, { attributes: true, attributeFilter: ['is-open'] });
      }
    });

    watcher.observe(document.body, { childList: true, subtree: true });
  };

  const handleScroll = () => {
    const stickyHeader = document.querySelector('.header-wrapper .header');
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const shopifyChat = document.getElementById('ShopifyChat');
    const backToTopButton = document.getElementById('back-to-top');
    const cartContainer = document.querySelector('[id^="cart-fixed-button-template-"]');
    const wishlistBlock = document.querySelector('[id*="__wishlist_hero_custom_product_button_"]');
    const shareButtonWrapper = document.querySelector('.share-button__wrapper');

    // 初回のみ実行
    if (!hasRun) {
      if (wishlistBlock && cartContainer) {
        wishlistBlock.classList.add('wishlist_hero_custom_product_button');

        if (cartContainer) {
          cartContainer.appendChild(wishlistBlock);
        }
      }
      hasRun = true;
    }

    // カートボタン固定切替え
    if (cartButton && typeof originalOffsetTop === 'number') {
      const shouldFix = scrollTop > originalOffsetTop;

      if (shouldFix !== isCartFixed) {
        cartButton.classList.toggle('show', shouldFix);
        isCartFixed = shouldFix;

        if (shopifyChat) {
          shopifyChat.classList.toggle('fixed-chat', shouldFix);
        }
        if (backToTopButton) {
          backToTopButton.classList.toggle('fixed-back-to-top', shouldFix);
        }
      }
    }
  };

  // 初期化処理
  const init = () => {
    initPrivacyPolicyCheck();
    initProductPrivacyPolicyCheck();
    initColorTextUpdater();
    initCartButtonTracking();
    initShippingDisplay();
    initReadMore();
    initThumbnailModal();
    initFreeShippingBarMargin();
    initCartNotification();
    initReplaceCheckTimeText();
    initBackToTopButton();
    initInbox();
    initInboxOpenState();
    handleScroll();
  };

  window.addEventListener('DOMContentLoaded', init);
  window.addEventListener('scroll', handleScroll);
})();